import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const TranscriptCourseIcon: FC<Props> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.14306 5.88418C6.4777 4.61034 8.34159 4.01044 10.4791 4.01044H21.7578C23.9004 4.01044 25.765 4.60992 27.0972 5.88521C28.4362 7.16702 29.1077 9.00737 29.1016 11.223V20.7674C29.1016 22.9831 28.427 24.8254 27.0876 26.1095C25.7546 27.3874 23.8902 27.9906 21.7461 27.9906H10.4791C8.33555 27.9906 6.46951 27.3746 5.13607 26.0768C3.79821 24.7748 3.12236 22.9094 3.12236 20.665V11.2219C3.12236 9.00458 3.80126 7.16488 5.14306 5.88418ZM6.52394 7.33097C5.66553 8.15028 5.12236 9.41629 5.12236 11.2219V20.665C5.12236 22.5071 5.66857 23.8043 6.53093 24.6435C7.3977 25.4871 8.71003 25.9906 10.4791 25.9906H21.7461C23.5264 25.9906 24.8398 25.4938 25.7034 24.6658C26.5606 23.8439 27.1016 22.5747 27.1016 20.7674V11.219C27.1069 9.4125 26.5685 8.14777 25.7142 7.32994C24.8526 6.50524 23.5396 6.01044 21.7578 6.01044H10.4791C8.70399 6.01044 7.38951 6.50481 6.52394 7.33097Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.71611 21.1094C8.71611 20.5571 9.16383 20.1094 9.71611 20.1094H12.6636C13.2159 20.1094 13.6636 20.5571 13.6636 21.1094C13.6636 21.6616 13.2159 22.1094 12.6636 22.1094H9.71611C9.16383 22.1094 8.71611 21.6616 8.71611 21.1094ZM18.9222 21.1094C18.9222 20.5571 19.37 20.1094 19.9222 20.1094H22.5077C23.06 20.1094 23.5077 20.5571 23.5077 21.1094C23.5077 21.6616 23.06 22.1094 22.5077 22.1094H19.9222C19.37 22.1094 18.9222 21.6616 18.9222 21.1094Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.79685 16.5C8.79685 15.9478 9.24455 15.5 9.79685 15.5H12.0022C12.5545 15.5 13.0022 15.9478 13.0022 16.5C13.0022 17.0523 12.5545 17.5 12.0022 17.5H9.79685C9.24455 17.5 8.79685 17.0523 8.79685 16.5ZM14.6088 16.5C14.6088 15.9478 15.0564 15.5 15.6088 15.5H18.73C19.2822 15.5 19.73 15.9478 19.73 16.5C19.73 17.0523 19.2822 17.5 18.73 17.5H15.6088C15.0564 17.5 14.6088 17.0523 14.6088 16.5Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0806 21.1094C15.0806 20.5571 15.5284 20.1094 16.0806 20.1094H16.094C16.6464 20.1094 17.094 20.5571 17.094 21.1094C17.094 21.6616 16.6464 22.1094 16.094 22.1094H16.0806C15.5284 22.1094 15.0806 21.6616 15.0806 21.1094Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4478 16.5C21.4478 15.9478 21.8956 15.5 22.4478 15.5H22.4612C23.0136 15.5 23.4612 15.9478 23.4612 16.5C23.4612 17.0523 23.0136 17.5 22.4612 17.5H22.4478C21.8956 17.5 21.4478 17.0523 21.4478 16.5Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.11194 11.4323C3.11194 10.88 3.55966 10.4323 4.11194 10.4323H28.112C28.6642 10.4323 29.112 10.88 29.112 11.4323C29.112 11.9846 28.6642 12.4323 28.112 12.4323H4.11194C3.55966 12.4323 3.11194 11.9846 3.11194 11.4323Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default TranscriptCourseIcon;
